import React, { useEffect, useState } from 'react';
import CustomContent from '../../../components/Content/CustomContent';
import { Button, DatePicker, Divider, Dropdown, Menu, Space, Table } from 'antd';
import request from '../../../utils/request';
import moment from 'moment';
import { history } from '../../../utils/history';
import { DownloadOutlined } from '@ant-design/icons';
import { host } from '../../../utils/config';
import * as axios from 'axios';
import { useTranslation } from 'react-i18next';

const { RangePicker } = DatePicker;

function ScanTable(props) {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  let initialState = [
    moment(new Date()).format("YYYY-MM-DD"),
    moment(new Date()).format("YYYY-MM-DD")
  ];
  const [dateRange, setDateRange] = useState(initialState);

  const onDateChange = (date, dateString) => {
    if (dateString[0] !== '' && dateString[1] !== '') {
      setDateRange(dateString);
    } else {
      setDateRange(initialState);
    }
  };

  const columns = [
    {
      title: t('appCms.beaconScan.uniqueId'),
      dataIndex: ['uniqueId'],
      key: 'uniqueId',
    },
    {
      title: t('appCms.beaconScan.scanCount'),
      dataIndex: ['count'],
      key: 'count',
    },
    {
      title: t('appCms.beaconScan.date'),
      dataIndex: ['date'],
      key: 'date'
    },
    {
      title: t('appCms.beaconScan.assignedPoiGroup'),
      dataIndex: ['pointOfInterestGroup'],
      key: 'pointOfInterestGroup',
      render: text =>
        text ? (
          <a
            aria-hidden="true"
            onClick={() => {
              history.push('/updatePoiGroup/' + text.id);
            }}
          >
            <span>{text.title}</span>
          </a>
        ) : (
          ''
        ),
    },
    {
      title: t('appCms.beaconScan.assignedPoi'),
      dataIndex: ['poiList'],
      key: 'poiList',
      render: (text, record) =>
        record.pointOfInterestGroup == null && text.length > 0 ? (
          <a
            aria-hidden="true"
            onClick={() => {
              history.push('/updatePoi/' + text[0].id);
            }}
          >
            <span>{text[0].title}</span>
          </a>
        ) : (
          ''
        ),
    },
  ];

  const handleDownload = action => {
    const bearer = localStorage.getItem('userToken');

    let options = {
      url: host + '/api/beacons/scans/export',
      method: 'GET',
      responseType: 'blob', // important
      headers: { Authorization: bearer },
      params: {
        startDate: dateRange[0],
        endDate: dateRange[1]
      }
    };

    axios(options).then(response => {
      const today = new Date();
      const currentDate =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'beacon-reports-' + currentDate + '.csv');
      document.body.appendChild(link);
      link.click();
    });
  };

  const exportMenu = (
    <Menu onClick={handleDownload}>
      <Menu.Item key="1">
        <DownloadOutlined />
        {' '}{t('appCms.beaconScan.allBeacons')}
      </Menu.Item>
    </Menu>
  );



  useEffect(() => {
    let call = request('/beacons/scans', {
      method: 'GET',
      params: {
        startDate: dateRange[0],
        endDate: dateRange[1]
      }
    });
    call().then(response => {
      if (response.status === 200) {
        setData(response.data);
      }
    })
  }, [dateRange]);

  return (
    <CustomContent>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>

        <RangePicker
          onChange={onDateChange}
          style={{ float: 'right', marginBottom: 16 }}
        />

        <Dropdown overlay={exportMenu}>
          <Button
            icon={<DownloadOutlined />}
            style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
          >
            {t('appCms.export')}
          </Button>
        </Dropdown>

      </div>

      <Divider />

      <Table
        columns={columns}
        dataSource={data}
        rowKey={record => record.uniqueId}
      />

    </CustomContent>
  );
}

export default ScanTable;
